import React,{useEffect,useState} from 'react';
import './comp_payment_receipt.css';
import logoImg from '../assets/images/logo.png';
import ResPicDef from '../assets/images/schoo_pic.png';
import {bindEdit} from '../function_lib/common_lib';
import { setRegion } from 'react-geocode';
export function exportReceiptPdf(pageType) {
    var whe = window.innerHeight;
    var wwid = window.innerWidth;

    let data = document.getElementById("print_fee_receipt").innerHTML;
    /*
    alert(data);
    var doc = new DOMParser().parseFromString(data, "text/xml");

    alert(doc.getElementsByTagName("<div>")[1]);
    */
    var printWindow = window.open('', '', 'width=' + (wwid - 20) + ',height=' + (whe - 10) + '');
    printWindow.document.write('<html><head><title>Print Receipt</title>');
    //printWindow.document.write('<link rel="stylesheet" href="~/plugins/fontawesome-free/css/all.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.datatables.net/1.12.1/css/jquery.dataTables.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="comp_payment_receipt.css?20042025.09233">');
    printWindow.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700">');
    if(pageType==="1"){
        printWindow.document.write('<style>@page { size: landscape; }table, th, td {border: 0.5px solid;}table{width:100%;border-spacing:0;}</style>');
    }else{
        printWindow.document.write('<style>table, th, td {border: 0.5px solid;}table{width:100%;border-spacing:0;}</style>');
    }
    
    
    printWindow.document.write('</head><body >');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
   

    setTimeout(function () {
        printWindow.print();
    }, 500);
    return false;
}

export const Comp_Payment_Receipt=(props)=>{
   
    return(
    <div id="print_fee_receipt">
     <div class="receipt-wrapper">

<div class="header">
    <div class="logo">
        <img src={logoImg} />
    </div>

    <div class="school-details">
        <h1>City Montessori School</h1>
        <p>Indira Nagar, Ujjain (M.P.)</p>
        <p>Phone:☎  0734-3562968</p>
    </div>
</div>

<div class="two-col-row">
<div class="field-row">
  <span class="field-label">Reciept No. :</span>
  <div class="field-line"><span class="field-value"></span></div>
</div>
<div class="field-row">
  <span class="field-label">Date :</span>
  <div class="field-line"><span class="field-value"></span></div>
</div>
</div>
<div class="field-row">
<span class="field-label">Name of Student</span>
<div class="field-line"><span class="field-value"></span></div>
</div>


<div class="field-row">
<span class="field-label">Father/Mother</span>
<div class="field-line"><span class="field-value"></span></div>
</div>

<div class="two-col-row">
<div class="field-row">
  <span class="field-label">Class</span>
  <div class="field-line"><span class="field-value"></span></div>
</div>
<div class="field-row">
  <span class="field-label">Section</span>
  <div class="field-line"><span class="field-value"></span></div>
</div>
</div>

<div class="fees-words-row">
<span class="field-label">Fees(in words)</span>
<div class="fees-words-line"><span class="field-value"></span></div>
</div>

<div class="month-row">
<span>received with follwing details from the month of</span>
<div class="month-line"><span class="field-value"></span></div>
</div>

<table class="fees-table">
<tr>

  <td >
    <div class="fee-item">
      <span>1. Tuition Fees</span>
      <div class="dotted-line"></div>
    </div>
    <div class="fee-item">
      <span>2. Admi Fees</span>
      <div class="dotted-line"></div>
    </div>
    <div class="fee-item">
      <span>3. Re-admi. Fees</span>
      <div class="dotted-line"></div>
    </div>
    <div class="fee-item">
      <span>4. Other</span>
      <div class="dotted-line"></div>
    </div>
    <div class="year-text"></div>
  </td>

  <td>
    <div class="fee-item">
      <span>2. Activity fees</span>
      <div class="dotted-line"></div>
    </div>
    <div class="fee-item">
      <span>4. Exam fees</span>
      <div class="dotted-line"></div>
    </div>
    <div class="fee-item">
      <span>5. Ven</span>
      <div class="dotted-line"></div>
    </div>
  </td>
</tr>

<tr class="total-row">
  <td>
    <span ><strong>Due</strong></span>
    <span ></span>
  </td>
  <td>
    <span ><strong>TOTAL</strong></span>
  </td>
</tr>

<tr class="due-row">
  <td></td>
  <td>
    <span><strong>GRAND TOTAL </strong></span>
    <span></span>
  </td>
</tr>
</table>


<div class="signature-section">
Receiver's Signature
<div class="sig-line"></div>
</div>

</div>
  </div>
  )

}
export default Comp_Payment_Receipt;